import React, { useEffect, useState } from 'react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import FAQSection from '../components/FAQSection';
import { games, faqs } from '../mockData';
import { Gamepad2, Star, TrendingUp, Filter, ChevronDown, ChevronUp } from 'lucide-react';

const Spiele = () => {
  const [filter, setFilter] = useState('all');
  const [filteredGames, setFilteredGames] = useState(games);
  const [isContentExpanded, setIsContentExpanded] = useState(false);

  useEffect(() => {
    document.title = 'Robocat Casino Spiele & Slots 2025 | Über 3000 Spiele';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Robocat Casino Spiele ⚡ Über 3000 Slots & Live Casino ✓ Pragmatic Play ✓ Evolution ✓ Play\'n GO ✓ Hohe RTP-Werte ✓ Jetzt spielen');
    }
  }, []);

  useEffect(() => {
    if (filter === 'all') {
      setFilteredGames(games);
    } else {
      setFilteredGames(games.filter(game => game.type === filter));
    }
  }, [filter]);

  const providers = [...new Set(games.map(g => g.provider))];

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 to-slate-900">
      {/* Hero Section with Banner */}
      <section className="relative py-20 md:py-32 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img 
            src="https://customer-assets.emergentagent.com/job_seo-casino-portal-1/artifacts/bcenk4oe_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-09%20%D0%B2%2007.13.30.png" 
            alt="Robocat Casino Spiele Banner" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-slate-950/95 via-slate-900/90 to-blue-950/95"></div>
        </div>
        
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-cyan-500 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-600 rounded-full blur-3xl"></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <Gamepad2 className="w-16 h-16 text-cyan-400 mx-auto mb-6" />
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Robocat Casino <span className="bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">Spiele</span> & Slots
            </h1>
            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              Entdecken Sie über 3.000 erstklassige Casino-Spiele von den besten Anbietern der Branche. Von hochvolatilen Slots bis hin zu Live-Casino-Erlebnissen - bei Robocat Casino finden Sie Ihr perfektes Spiel.
            </p>
            <Button 
              size="lg" 
              className="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white font-bold px-8 py-6 text-lg shadow-2xl shadow-cyan-500/50 hover:shadow-cyan-500/70 transition-all duration-300"
              onClick={() => alert('Demo: Jetzt spielen')}
            >
              <Gamepad2 className="mr-2 w-5 h-5" />
              Jetzt spielen
            </Button>
          </div>
        </div>
      </section>

      {/* Filters */}
      <section className="py-8 bg-slate-950 border-b border-slate-800">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-center space-x-2 flex-wrap gap-2">
            <Filter className="w-5 h-5 text-cyan-400" />
            <Button
              onClick={() => setFilter('all')}
              className={filter === 'all' ? 'bg-gradient-to-r from-cyan-500 to-blue-600 text-white' : 'bg-slate-800 text-gray-300 hover:bg-slate-700'}
            >
              Alle Spiele
            </Button>
            <Button
              onClick={() => setFilter('Slot')}
              className={filter === 'Slot' ? 'bg-gradient-to-r from-cyan-500 to-blue-600 text-white' : 'bg-slate-800 text-gray-300 hover:bg-slate-700'}
            >
              Slots
            </Button>
            <Button
              onClick={() => setFilter('Live Casino')}
              className={filter === 'Live Casino' ? 'bg-gradient-to-r from-cyan-500 to-blue-600 text-white' : 'bg-slate-800 text-gray-300 hover:bg-slate-700'}
            >
              Live Casino
            </Button>
          </div>
        </div>
      </section>

      {/* Games Grid */}
      <section className="py-16 bg-slate-950">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-white mb-8 text-center">Top Robocat Casino Spiele</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
              {filteredGames.map((game) => (
                <Card key={game.id} className="bg-slate-800/50 border-cyan-500/20 overflow-hidden hover:shadow-xl hover:shadow-cyan-500/20 transition-all duration-300 group">
                  <div className="aspect-video relative overflow-hidden">
                    <img 
                      src={game.image} 
                      alt={game.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent"></div>
                    <div className="absolute top-3 right-3 bg-slate-900/80 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-semibold text-cyan-400 border border-cyan-500/30">
                      {game.type}
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-lg font-bold text-white mb-2 line-clamp-2">{game.name}</h3>
                    <div className="flex items-center justify-between text-sm mb-3">
                      <span className="text-gray-400">{game.provider}</span>
                      <div className="flex items-center space-x-1">
                        <Star className="w-4 h-4 text-yellow-400 fill-yellow-400" />
                        <span className="text-white font-semibold">{game.rating}</span>
                      </div>
                    </div>
                    <p className="text-sm text-gray-400 mb-4 line-clamp-2">{game.description}</p>
                    <div className="grid grid-cols-2 gap-3 mb-4 text-xs">
                      <div className="bg-slate-900/50 rounded p-2">
                        <div className="text-gray-500">RTP</div>
                        <div className="text-cyan-400 font-bold">{game.rtp}</div>
                      </div>
                      <div className="bg-slate-900/50 rounded p-2">
                        <div className="text-gray-500">Volatilität</div>
                        <div className="text-cyan-400 font-bold">{game.volatility}</div>
                      </div>
                    </div>
                    <Button 
                      className="w-full bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white font-semibold"
                      onClick={() => alert('Demo: Spiel starten')}
                    >
                      Jetzt spielen
                    </Button>
                  </div>
                </Card>
              ))}
            </div>

            {/* Games Table */}
            <div className="bg-slate-800/50 border border-cyan-500/20 rounded-xl overflow-hidden backdrop-blur-sm">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-slate-900/50 border-b border-cyan-500/20">
                    <tr>
                      <th className="px-6 py-4 text-left text-sm font-semibold text-cyan-400">Spiel</th>
                      <th className="px-6 py-4 text-left text-sm font-semibold text-cyan-400">Anbieter</th>
                      <th className="px-6 py-4 text-center text-sm font-semibold text-cyan-400">RTP</th>
                      <th className="px-6 py-4 text-center text-sm font-semibold text-cyan-400">Bewertung</th>
                      <th className="px-6 py-4 text-center text-sm font-semibold text-cyan-400">Volatilität</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-700">
                    {filteredGames.map((game) => (
                      <tr key={game.id} className="hover:bg-slate-700/30 transition-colors">
                        <td className="px-6 py-4 text-white font-medium">{game.name}</td>
                        <td className="px-6 py-4 text-gray-300">{game.provider}</td>
                        <td className="px-6 py-4 text-center">
                          <span className="text-cyan-400 font-semibold">{game.rtp}</span>
                        </td>
                        <td className="px-6 py-4 text-center">
                          <div className="flex items-center justify-center space-x-1">
                            <Star className="w-4 h-4 text-yellow-400 fill-yellow-400" />
                            <span className="text-white font-semibold">{game.rating}</span>
                          </div>
                        </td>
                        <td className="px-6 py-4 text-center text-gray-300">{game.volatility}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Game Providers */}
      <section className="py-16 bg-slate-900">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-white mb-8 text-center">Top Spieleanbieter bei Robocat Casino</h2>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              {providers.map((provider, index) => (
                <Card key={index} className="bg-slate-800/50 border-cyan-500/20 p-6 text-center hover:border-cyan-500/50 transition-all duration-300">
                  <TrendingUp className="w-8 h-8 text-cyan-400 mx-auto mb-2" />
                  <div className="text-white font-semibold">{provider}</div>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* SEO Content Section with Dropdown - Before FAQ */}
      <section className="py-16 bg-slate-900">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-slate-800/50 border border-cyan-500/20 rounded-2xl overflow-hidden">
              <button
                onClick={() => setIsContentExpanded(!isContentExpanded)}
                className="w-full px-8 py-6 flex items-center justify-between hover:bg-slate-800/70 transition-colors"
              >
                <h2 className="text-2xl md:text-3xl font-bold text-white text-left">
                  Robocat Casino Spiele: Vollständiger Überblick 2025
                </h2>
                {isContentExpanded ? (
                  <ChevronUp className="w-6 h-6 text-cyan-400 flex-shrink-0 ml-4" />
                ) : (
                  <ChevronDown className="w-6 h-6 text-cyan-400 flex-shrink-0 ml-4" />
                )}
              </button>
              
              <div className="px-8 pb-8 space-y-6">
                <p className="text-gray-300 leading-relaxed">
                  Das Robocat Casino Spielportfolio ist beeindruckend und vielfältig. Mit über 3.000 Spielen von mehr als 50 renommierten Anbietern bietet die Plattform eine der größten Spielsammlungen in Deutschland...
                </p>
                
                {isContentExpanded && (
                  <div className="space-y-6 animate-in slide-in-from-top duration-300">
                    <p className="text-gray-300 leading-relaxed">
                      Mit über 3.000 Spielen von mehr als 50 renommierten Anbietern bietet die Plattform eine der größten Spielsammlungen in Deutschland. Von klassischen Slots über moderne Video-Slots mit innovativen Features bis hin zu Live-Casino-Spielen mit professionellen Dealern - Robocat Casino deckt alle Bedürfnisse ab. Die Robocat Slots sind besonders beliebt bei deutschen Spielern, da sie hohe RTP-Werte (Return to Player) und spannende Bonusfunktionen bieten.
                    </p>
                    
                    <img 
                      src="https://customer-assets.emergentagent.com/job_seo-casino-portal-1/artifacts/lbxrwrq2_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-09%20%D0%B2%2004.51.05.png" 
                      alt="Robocat Casino Spielportfolio" 
                      className="w-full rounded-lg border border-cyan-500/20 shadow-xl"
                    />
                    
                    <p className="text-gray-300 leading-relaxed">
                      Zu den Top-Anbietern bei Robocat Casino gehören Pragmatic Play, Evolution Gaming, Play'n GO, Hacksaw Gaming, Fazi, NetEnt, Microgaming und Yggdrasil. Jeder dieser Anbieter bringt seine eigene Stärke mit: Pragmatic Play ist bekannt für hochvolatile Slots mit massiven Multiplikatoren wie Gates of Olympus Super Scatter und Sweet Bonanza 1000. Evolution Gaming dominiert den Live-Casino-Bereich mit Spielen wie Gold Saloon Roulette und bietet ein authentisches Casino-Erlebnis mit HD-Streaming. Play'n GO liefert ikonische Titel wie Legacy of Dead, während Hacksaw Gaming mit innovativen Mechaniken wie bei The Luxe überrascht.
                    </p>
                    
                    <p className="text-gray-300 leading-relaxed">
                      Der RTP (Return to Player) ist ein entscheidender Faktor bei der Auswahl von Robocat Casino Spielen. Die meisten Slots bei Robocat haben einen RTP von 96% oder höher, was über dem Branchendurchschnitt liegt. Gold Saloon Roulette von Evolution bietet beispielsweise einen hervorragenden RTP von 97,30%, während Legacy of Dead bei 96,58% liegt. Ein höherer RTP bedeutet, dass langfristig ein größerer Anteil der Einsätze an die Spieler zurückgezahlt wird, was Ihre Gewinnchancen verbessert.
                    </p>
                    
                    <p className="text-gray-300 leading-relaxed">
                      Die Volatilität ist ein weiterer wichtiger Aspekt beim Robocat Casino Spielen. Hochvolatile Slots wie Sweet Bonanza 1000 und Legacy of Dead bieten seltener, aber dafür höhere Gewinne, während Spiele mit niedriger Volatilität wie Gold Saloon Roulette häufigere, aber kleinere Auszahlungen bieten. Wählen Sie die Volatilität basierend auf Ihrem Spielstil und Ihrer Risikotoleranz. Alle Robocat Spiele können im Demo-Modus kostenlos getestet werden, sodass Sie Ihre Favoriten finden können, bevor Sie mit Echtgeld spielen.
                    </p>
                  </div>
                )}
                
                <button
                  onClick={() => setIsContentExpanded(!isContentExpanded)}
                  className="text-cyan-400 hover:text-cyan-300 font-semibold transition-colors flex items-center space-x-2"
                >
                  <span>{isContentExpanded ? 'Weniger anzeigen' : 'Mehr anzeigen'}</span>
                  {isContentExpanded ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <FAQSection faqs={faqs.spiele} title="Häufige Fragen zu Robocat Casino Spielen" />
    </div>
  );
};

export default Spiele;
